import { InjectionToken } from '@angular/core';
import { RxState } from '@rx-angular/state';
import { ICar } from 'common_library';
import { AppMainState, MainState } from './types/state/app-main-state.interface';

/**
 * Token e tipi dello stato globale, fuori da `app.module`.
 *
 * Stavano dentro `app.module.ts`: ogni service che li importava (http-io, socket-io,
 * app-main-state, auth, ...) si tirava dietro l'intero modulo dell'applicazione, creando un ciclo
 * di import `service → app.module → ComponentsModule → component → service`. In produzione passava
 * inosservato, ma faceva fallire il caricamento della suite di test ("Cannot access X before
 * initialization") e rendeva impossibile testare un singolo service.
 */

export type Nullable<T> = T | null;

export interface IFormCdc {
  owner?: string;
  number?: string;
  expiryMonth?: number;
  expiryYear?: number;
  securityCode?: number;
}

export interface GlobalState {
  apiUrl: string,
  mainState: MainState,
  selectedCar: Nullable<ICar>,
  visible: boolean, // indica se l'app è visibile all'utente oppure no (tipo il tab è visibile sia mobile che desktop) -> vedere AppService
  wsComm: boolean,
  httpComm: boolean,
  isDevelop: boolean,
  openByAction: boolean,
  installationByDeeplink: boolean,
  mapLoaded: boolean,
  registrationForm: {
    name?: string,
    surname?: string,
    email?: string,
    password: '',
  },
  formCdc: IFormCdc
}

export const GLOBAL_RX_STATE = new InjectionToken<RxState<GlobalState>>('GLOBAL_RX_STATE');
export const APP_MAIN_RX_STATE = new InjectionToken<RxState<AppMainState>>('APP_MAIN_RX_STATE');
